<template>
    <div class="header">
        <div class="header-container">
            <div class="container-fluid header-219 header-fixed header-default img-fluid"
                 :style="{
                    backgroundColor: colorBg,
                    backgroundImage: 'url(' + coverUrl + ')'
                }">
            </div>
        </div>
    </div>

</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
    name: "Header",
    props: {
        coverUrl: null,
        model: {
            type: String,
            default: 'event'
        }
    },
    computed: {
        ...mapGetters('color', ['getColorForModel']),
        colorBg: function () {
            return this.getColorForModel(this.model)
        },
    }
}
</script>

